import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
            最新h漫文章
          </h2>
          <p className="text-sm text-foreground-500">持续更新，追踪h漫领域最新动态与深度解读</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {latest.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-md transition-all cursor-pointer"
          >
            <div className="flex-shrink-0 w-24 h-24 rounded-lg overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex-1 min-w-0">
              <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-1.5 whitespace-nowrap">
                {article.categoryName}
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1.5 leading-snug">
                {article.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>{article.date}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views.toLocaleString()}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}